import React, {PureComponent} from "react"

import {CheckoutRedemption} from "@irati/types"
import {FormattedMessage} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import modalImage from "@irati/ui/images/success-tickets-2.svg"
import Loading from "@irati/ui/src/Loading"
import {Body, H2} from "@irati/ui/src/Typography"
import GenericModal from "@irati/ui/src/GenericModal"

import SelectedPerkDetails from "./SelectedPerkDetails"

import {StyledHr, StyledError, ResponsiveFlex, ResponsiveButton} from "./styled/MarkPerkAsUsedPopup"

interface Props {
  redemption: CheckoutRedemption,
  show: boolean,
  onHide: () => void,
  onSubmit: (redemption: CheckoutRedemption) => Promise<void>
}

interface State {
  submit: null | Promise<unknown>
}

class MarkPerkAsUsedPopup extends PureComponent<Props, State> {
  state = {
    submit: null
  }

  handleMarkRedemption = () => {
    const submit = this.props.onSubmit(this.props.redemption)
    this.setState({submit})
    return submit
  }

  render() {
    const {redemption, show, onHide} = this.props
    const {submit} = this.state

    return (
      <GenericModal
        show={show}
        onHide={onHide}
        image={modalImage}
        actions={
          <ResponsiveFlex justifyContent="flex-end" marginTop={3}>
            <Button tertiary onClick={onHide} marginRight={1.5}>
              <FormattedMessage id="perks.myPerks.markPerkAsUsedPopup.button.no" />
            </Button>
            <ResponsiveButton id="YesMarkAsUsedButtonId" primary load={submit} onClick={this.handleMarkRedemption}>
              <FormattedMessage id="perks.myPerks.markPerkAsUsedPopup.button.yes" />
            </ResponsiveButton>
          </ResponsiveFlex>
        }>
        <H2 margin={[1, 0]}>
          <FormattedMessage id="perks.myPerks.markPerkAsUsedPopup.header" />
        </H2>
        <Body small marginBottom={2}>
          <FormattedMessage id="perks.myPerks.markPerkAsUsedPopup.subHeader" />
        </Body>
        <StyledHr />
        <SelectedPerkDetails redemption={redemption} />
        <StyledHr />
        <StyledError>
          <Loading load={submit} useLoader={false} />
        </StyledError>
      </GenericModal>
    )
  }
}

export default MarkPerkAsUsedPopup
